import { ReactNode } from 'react';

import { DropdownMenuItemLi } from './DropdownMenuItem.styled';

type Props = {
  children: ReactNode;
  qaId?: string;
};

export function DropdownMenuItem({ children, qaId }: Props) {
  return <DropdownMenuItemLi data-qa-id={qaId}>{children}</DropdownMenuItemLi>;
}
